module.exports = __webpack_public_path__ + "img/dashboard_automation_icon.88b7bb4b.svg";